import { SurveysRoutes } from './type'

const surveys = `${SurveysRoutes.root}`
const edit = (id: number) => `${surveys}/${SurveysRoutes.edit}/${id}`
const view = (id: number) => `${surveys}/${SurveysRoutes.view}/${id}`

export const SurveysPath = {
  root: surveys,
  create: `${surveys}/${SurveysRoutes.create}`,
  edit: edit,
  view: view,
}
